import { tAnswer } from 'common/modules/ReactShared';
import { getApi } from '../apiClient';
import { lessonPath } from '../lesson/api';
import {
  ILessonTaskGetResponse,
  ITaskSessionNextPostResponse,
  ITaskSessionGetResponse,
  ITaskSessionAnswerPutRequest,
  ITaskSessionAnswerPutResponse,
  ISubmitFeedbackBody,
  ISpeechItemSessionResponse
} from './types';

export async function fetchLessonTask(
  lessonId: number,
  taskId: number,
  preview = false
): Promise<ILessonTaskGetResponse> {
  const { data } = await getApi().get<ILessonTaskGetResponse>(
    `${lessonPath(lessonId, preview)}/tasks/${taskId}`
  );
  return data;
}

// taskSession
export async function fetchTaskSession(
  lessonId: number,
  taskId: number,
  preview = false
): Promise<ITaskSessionGetResponse> {
  const { data } = await getApi().get(
    `${lessonPath(lessonId, preview)}/tasks/${taskId}/session`
  );
  return data;
}

export async function restartTaskSession(
  lessonSessionId: number,
  taskSessionId: number
): Promise<ITaskSessionGetResponse> {
  const { data } = await getApi().post(
    `/lesson_sessions/${lessonSessionId}/task_sessions/${taskSessionId}/restart`
  );
  return data;
}

export async function nextLessonTaskSession(
  lessonSessionId: number
): Promise<ITaskSessionNextPostResponse> {
  const { data } = await getApi().post<ITaskSessionNextPostResponse>(
    `/lesson_sessions/${lessonSessionId}/task_sessions/next`
  );
  return data;
}

export async function submitAnswersLessonTask(
  taskSessionUrl: string,
  answer: ITaskSessionAnswerPutRequest['answer']
): Promise<ITaskSessionAnswerPutResponse> {
  const body: ITaskSessionAnswerPutRequest = { answer };
  const { data } = await getApi().put<ITaskSessionAnswerPutResponse>(
    `${taskSessionUrl}/answer`,
    body
  );
  return data;
}

export async function submitAnswersLessonTaskItem(
  url: string,
  taskItemSession: tAnswer[number]
): Promise<ITaskSessionAnswerPutResponse> {
  const { data } = await getApi().put<ITaskSessionAnswerPutResponse>(url, {
    taskItemSession
  });

  return data;
}

export async function submitSpeechAnswer(
  url: string,
  audioBlob: Blob
): Promise<ISpeechItemSessionResponse> {
  const formData = new FormData();
  const ext = audioBlob.type === 'audio/wav' ? 'wav' : 'mp3';
  formData.append('task_item_session[audio]', audioBlob, `audio.${ext}`);
  const { data } = await getApi().patch<{ taskItemSession: ISpeechItemSessionResponse }>(
    url,
    formData
  );
  return data.taskItemSession;
}

export async function heartBeat(taskSessionUrl: string): Promise<void> {
  await getApi().put(`${taskSessionUrl}/heartbeat`);
}

export async function submitLessonTaskFeedback(
  lessonId: number,
  taskId: number,
  body: ISubmitFeedbackBody
): Promise<void> {
  return getApi().post(`/lessons/${lessonId}/tasks/${taskId}/feedback`, {
    feedback: body
  });
}
